module.exports = __webpack_public_path__ + "img/finance_-68-128.0fa2a632.png";